import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import Box from 'ui-box';
import { InputGroup, majorScale, minorScale } from '.';
import { CompanySelect } from '../components/companies/CompanySelect';
import { CountrySelect } from './CountrySelect';

export const AddressFormControls = ({
  name,
  showCompanySelect = false,
}: {
  name: string;
  showCompanySelect?: boolean;
}) => {
  const { register, errors, control, setValue } = useFormContext();
  const intl = useIntl();
  return (
    <>
      {showCompanySelect && (
        <>
          <CompanySelect
            placeholder={intl.formatMessage({
              defaultMessage: 'Choose from a company',
            })}
            onSelect={(company) => {
              setValue(
                name,
                company.address || {
                  country: null,
                  addressLine1: '',
                  addressLine2: '',
                  postalCode: '',
                  city: '',
                }
              );
            }}
          />
          <Box
            className="p small muted"
            marginBottom={majorScale(2)}
            marginTop={minorScale(3)}
          >
            <FormattedMessage defaultMessage="Choose an address from a company or enter the address below" />
          </Box>
        </>
      )}
      <Controller
        control={control}
        name={`${name}.country`}
        defaultValue="DK"
        rules={{
          required: intl.formatMessage({
            defaultMessage: 'Please select a country',
          }),
        }}
        render={({ onChange, value }) => (
          <CountrySelect value={value} onChange={onChange} />
        )}
      />
      {errors[name] && errors[name].country && (
        <Box
          className="p small muted danger"
          marginBottom={majorScale(1)}
          marginTop={minorScale(1)}
        >
          {errors[name].country.message}
        </Box>
      )}
      <InputGroup
        placeholder={intl.formatMessage({
          defaultMessage: 'Address line 1',
        })}
        name={`${name}.address_line1`}
        defaultValue=""
        ref={register}
      />
      <InputGroup
        placeholder={intl.formatMessage({
          defaultMessage: 'Address line 2',
        })}
        name={`${name}.address_line2`}
        defaultValue=""
        ref={register}
      />
      <InputGroup
        placeholder={intl.formatMessage({
          defaultMessage: 'Postal code',
        })}
        name={`${name}.postal_code`}
        defaultValue=""
        ref={register}
      />
      <InputGroup
        placeholder={intl.formatMessage({
          defaultMessage: 'City',
        })}
        name={`${name}.city`}
        defaultValue=""
        ref={register}
      />
    </>
  );
};
